export const APP_URL = process.env.NEXT_PUBLIC_APP_URL
export const SCAN_URL = process.env.NEXT_PUBLIC_APP_SCAN_URL

export const CONTRACT_LOCKUP = process.env.NEXT_PUBLIC_CONTRACT_LOCKUP
